<template>
    <v-col cols="12" xl="10" class="py-10 px-0">
        <v-row>
            <v-col cols="12" lg="4" class="py-0">
                <b-input
                    to-mutate="pharmacy_sites::pharmacy_site.site_name"
                    :label="t('pharmacy-sites::form.label.site_name')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.site_name"
                    mandatory
                ></b-input>
            </v-col>
            <v-col cols="12" lg="4" class="py-0">
                <div style="width: max-content" class="pl-2 pl-md-0">
                    <b-switch
                        to-mutate="pharmacy_sites::pharmacy_site.is_registered"
                        :label="t('pharmacy-sites::form.label.is_registered')"
                        :readonly="readOnlyRules"
                    ></b-switch>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <h5 class="m-0">{{ t('pharmacy-sites::form.title.address') }}</h5>
            </v-col>
            <v-col cols="12" lg="4" class="py-0">
                <b-input
                    to-mutate="pharmacy_sites::pharmacy_site.address"
                    :label="t('pharmacy-sites::form.label.address')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.address"
                ></b-input>
            </v-col>
            <v-col cols="12" lg="4" class="py-0">
                <b-input
                    to-mutate="pharmacy_sites::pharmacy_site.post_code"
                    :label="t('pharmacy-sites::form.label.post_code')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.post_code"
                ></b-input>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <h5 class="m-0">{{ t('pharmacy-sites::form.title.contact_details') }}</h5>
            </v-col>
            <v-col cols="12" lg="4" class="py-0">
                <b-input
                    to-mutate="pharmacy_sites::pharmacy_site.phone"
                    :label="t('pharmacy-sites::form.label.phone')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.phone"
                ></b-input>
            </v-col>
            <v-col cols="12" lg="4" class="py-0">
                <b-input
                    to-mutate="pharmacy_sites::pharmacy_site.fax"
                    :label="t('pharmacy-sites::form.label.fax')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.fax"
                ></b-input>
            </v-col>
            <v-col cols="12" lg="4" class="py-0">
                <b-input
                    to-mutate="pharmacy_sites::pharmacy_site.email"
                    :label="t('pharmacy-sites::form.label.email')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.email"
                ></b-input>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <h5 class="m-0">{{ t('pharmacy-sites::form.title.pharmacy_group') }}</h5>
            </v-col>
            <v-col cols="12" lg="4" class="py-0">
                <b-select
                    id="pharmacy_groups"
                    to-mutate="pharmacy_sites::pharmacy_site.pharmacy_groups"
                    :label="t('pharmacy-sites::form.label.pharmacy_group')"
                    :select-items="pharmacyGroupOptions"
                    :readonly="readOnlyRules"
                    multiple
                    item-text="name"
                    item-value="id"
                    component-name="v-autocomplete"
                ></b-select>
            </v-col>
            <v-col cols="12" lg="4" class="py-0">
                <b-select
                    id="blood_result_providers"
                    :clearable="false"
                    :label="t('pharmacy-sites::form.label.blood_providers')"
                    :readonly="readOnlyRules"
                    :select-items="bloodProvidersOptions"
                    component-name="v-autocomplete"
                    item-text="name"
                    item-value="id"
                    multiple
                    to-mutate="pharmacy_sites::pharmacy_site.blood_result_providers"
                ></b-select>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
export default {
    data() {
        return {
            validationRules: {
                site_name: [(v) => !!v || t('users::validation.field.required')],
                address: [],
                post_code: [this.$root.rules.postCode],
                phone: [this.$root.rules.phone],
                fax: [this.$root.rules.fax],
                email: [this.$root.rules.email],
            },
        };
    },
    computed: {
        readOnlyRules() {
            const urlParams = new URLSearchParams(window.location.search);
            const preview = urlParams.get('preview');
            const isPreviewMode = preview && preview === 'true';
            if (isPreviewMode) {
                return true;
            }
            return !this.can('api.v1.pharmacy-sites.update') && this.can('api.v1.pharmacy-sites.show');
        },
        pharmacyGroupOptions() {
            return this.$store.state.pharmacy_sites.pharmacyGroupOptions;
        },
        bloodProvidersOptions() {
            let result = [];
            const types = [
                { type: 'astm', title: 'ASTM Devices' },
                { type: 'cc', title: 'Collection Centres' },
                { type: 'lab', title: 'Laboratories' },
            ];

            for (let type of types) {
                const filterType = this.$store.state.pharmacy_sites.bloodProvidersOptions.filter(
                    (x) => x.type === type.type
                );

                if (filterType.length) {
                    result.push({ header: type.title }, ...filterType);
                }
            }

            return result.map((x) => Object.assign(x, { disabled: x.type === 'astm' || x.disabled }));
        },
    },
};
</script>

<style lang="scss">
#pharmacy_groups,
#blood_result_providers {
    .v-input__slot {
        width: 100% !important;
    }
}
</style>
